import * as React from 'react'

const SvgData = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.35}
      d='m23.341 16.365.064-.101-.004-.009c.216-.37.349-.795.349-1.255a2.5 2.5 0 0 0-2.024-2.453L17.5 11.25V5A2.5 2.5 0 0 0 15 2.5c-.89 0-1.666.469-2.11 1.17l-.006-.001-6.18 9.901a2.482 2.482 0 0 0 1.349 3.819l.002.007L12.5 18.75V25a2.491 2.491 0 0 0 4.711 1.142l6.1-9.73c.012-.016.02-.032.03-.047Z'
      fill='#101AA1'
    />
    <path
      d='M2.5 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM5.367 8.384a1.247 1.247 0 0 0 1.767 0 1.249 1.249 0 0 0 0-1.768l-2.5-2.5a1.249 1.249 0 1 0-1.767 1.768l2.5 2.5ZM5.367 21.616l-2.5 2.5a1.249 1.249 0 1 0 1.767 1.768l2.5-2.5a1.249 1.249 0 1 0-1.767-1.768ZM27.5 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM24.634 21.616a1.249 1.249 0 0 0-1.767 0 1.249 1.249 0 0 0 0 1.768l2.5 2.5a1.247 1.247 0 0 0 1.767 0 1.249 1.249 0 0 0 0-1.768l-2.5-2.5ZM24.634 4.116a1.249 1.249 0 0 0-1.767 0l-2.5 2.5a1.249 1.249 0 0 0 .883 2.134c.32 0 .64-.123.884-.366l2.5-2.5a1.249 1.249 0 0 0 0-1.768Z'
      fill='#101AA1'
    />
  </svg>
)

export default SvgData
